import { styled } from '@ori-ui/mui';
export var DialogRoot = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiOriDialog-header': {
      paddingBottom: theme.spacing(6)
    },
    '& .MuiOriDialog-content': {
      maxWidth: 540
    }
  };
});
//# sourceMappingURL=styles.js.map